import { render, staticRenderFns } from "./TransProgramSeniors.vue?vue&type=template&id=f8034b98"
import script from "./TransProgramSeniors.vue?vue&type=script&lang=ts"
export * from "./TransProgramSeniors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports